import * as Sentry from '@sentry/react';
import {useChekinSDK} from 'context/ChekinSDK';
import {useMutation} from '@tanstack/react-query';
import {useCallback} from 'react';
import {getIVIntentRemoteSession} from 'hooks/iv/useIVRemoteSync';

export const useIVCompleted = () => {
  const sdk = useChekinSDK();

  const {mutate: finishIVByQr, isLoading} = useMutation(sdk.finishIVByQr, {
    onError: error => {
      Sentry.captureException(error);
    },
  });

  const returnToDesktop = useCallback(() => {
    const intentId = getIVIntentRemoteSession();
    if (intentId) {
      finishIVByQr({
        iv_intent_id: intentId,
        continue_on_mobile: false,
      });
    }
  }, [finishIVByQr]);

  const continueOnPhone = useCallback(() => {
    const intentId = getIVIntentRemoteSession();
    if (intentId) {
      finishIVByQr({
        iv_intent_id: intentId,
        continue_on_mobile: true,
      });
    }
  }, [finishIVByQr]);

  return {
    isLoading,
    returnToDesktop,
    continueOnPhone,
  };
};
